/** @format */

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

import { Logger } from '@shared/data-access/services';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

const X_LOG_REQUEST = 'X-LOG-REQUEST';

@Injectable()
export class LogInterceptor implements HttpInterceptor {
	/**
	 * @description
	 * Logger singleton
	 */
	get logger(): Logger {
		return this.injector.get(Logger);
	}

	constructor(private injector: Injector) {
		// Construct...
	}

	/**
	 * @description
	 * Function that acts as an Interceptor for all HTTP Requests.  It ensures that
	 * all necessary WCS Auth Tokens are set on every HTTP Request as needed and provides
	 * any common required Headers.
	 */
	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Get the start time of the Request
		const started = Date.now();

		// Cloned headers
		let headers = request.headers;

		// Flag for log XHR
		let isLogRequest = false;

		/*
		 * TODO: HEADER HACK UNTIL HTTPCLIENT OPTIONS ARE IMPLEMENTED -- SEE `https://github.com/angular/angular/issues/18155`
		 */
		if (request.headers.has(X_LOG_REQUEST)) {
			// Modify the headers accordingly
			headers = headers.delete(X_LOG_REQUEST);

			// Set the flag to true
			isLogRequest = true;
		}

		// Clone the Request with new headers
		const clonedRequest = request.clone({
			headers
		});

		// Continue with the cloned request
		return next.handle(clonedRequest).pipe(
			finalize(() => {
				// Get the end time of the Request and find the elapsed time
				const elapsed = Date.now() - started;

				// Check to see if the current request is a logger request
				if (isLogRequest) {
					console.debug(
						`LogInterceptor.intercept -- ${request.method} "${request.urlWithParams}" completed in ${elapsed}ms`
					); // eslint-disable-line no-console
				} else {
					// Log the duration of the Request
					this.logger.debug(
						`LogInterceptor.intercept -- ${request.method} "${request.urlWithParams}" completed in ${elapsed}ms`
					);
				}
			})
		);
	}
}
